// 🚫 DEFAULT RAILS INCLUDES
// This section represents the default includes for a Rails application. Bullet Train's includes and your own
// includes should be specified at the end of the file, not in this section. This helps avoid merge conflicts in the
// future should the framework defaults change.

import * as ActiveStorage from "@rails/activestorage"
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

ActiveStorage.start()

// 🚫 DEFAULT BULLET TRAIN INCLUDES
// This section represents the default settings for a Bullet Train application. Your own includes should be specified
// at the end of the file. This helps avoid merge conflicts in the future, should we need to change our own includes.

import "./support/jstz";

import "@bullet-train/bullet-train"
import "@bullet-train/bullet-train-sortable"

require("@icon/themify-icons/themify-icons.css")

import { trixEditor } from "@bullet-train/fields"
trixEditor()

// ✅ YOUR APPLICATION'S INCLUDES
// If you need to customize your application's includes, this is the place to do it. This helps avoid merge
// conflicts in the future when Rails or Bullet Train update their own default includes.
import Chart from 'chart.js/auto';

document.addEventListener("turbo:click", (event) => {
    const link = event.target.closest('a')
    const direction = link?.dataset.turboVisitDirection
    
    if (direction === "back") {
      window.visitDirection = "back"
    } else if (direction === "forward") {
      window.visitDirection = "forward"
    } else {
      window.visitDirection = "none"
    }
  });
  
  document.addEventListener("turbo:visit", (event) => {
      // this way you don't override browser back button navigation
      if (window.visitDirection) {
          document.documentElement.dataset.turboVisitDirection = window.visitDirection
      }
      window.visitDirection = undefined;
  });
  
  document.addEventListener('turbo:before-frame-render', (event) => {
    if (document.startViewTransition) {
      const originalRender = event.detail.render
  
      event.detail.render = (currentElement, newElement) => {
        document.startViewTransition(() => originalRender(currentElement, newElement))
      }
    }
  })
